var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OriginModeEnum, WIDGET_CONVERSATION_TYPE, WIDGET_MODE, WIDGET_REFERRER_ID, ErrorCode, } from "./models";
import { GenesysChatApiService } from "./genesys.chat.api.service";
import { GenesysChatPremiseService } from "./genesys.chat.premise.service";
import { codeError, timeout } from "./utils";
export class GenesysChatCloudService extends GenesysChatPremiseService {
    constructor(config, handlers) {
        super({
            pcEnvironment: config.pcEnvironment,
            chatMode: config.chatMode,
            kioskMode: config.kioskMode,
            customDomain: config.customDomain,
            pcWidgetScriptUrl: config.pcWidgetScriptUrl,
            pcWidgetPluginsPath: config.pcWidgetPluginsPath,
        }, handlers);
        this.config = config;
        this.handlers = handlers;
        this._apiService = new GenesysChatApiService(config, handlers, false);
    }
    sendMessage(message, bodyType = "standard", metadata) {
        switch (bodyType) {
            case "notice":
                // 'notice' seems to be not supported, so we fall-back to api call
                // this transport doesnt support 'notice' command
                return this._apiService.sendMessage(message, "notice", this.$conversation);
            case "standard":
                return super.sendMessage(message, bodyType, metadata);
        }
    }
    loadConfig() {
        const dataURL = `https://api.${this.config.pcEnvironment}`;
        const widgetCloudConfig = {
            widgets: {
                main: {
                    downloadGoogleFont: false,
                },
                webchat: {
                    transport: {
                        type: "purecloud-v2-sockets",
                        dataURL,
                        deploymentKey: this.config.pcDeploymentId,
                        orgGuid: this.config.pcOrganizationId,
                        interactionData: {
                            routing: {
                                targetType: "QUEUE",
                                targetAddress: this.config.pcQueue,
                                priority: 2,
                            },
                        },
                    },
                },
            },
        };
        globalThis._genesys = widgetCloudConfig;
    }
    createChat(contact, conversationType) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const form = {
                form: {
                    autoSubmit: false,
                    firstname: contact.firstName,
                    lastname: contact.lastName,
                    email: contact.email,
                    subject: contact.subject,
                },
                userData: Object.assign(Object.assign({}, contact), { [WIDGET_REFERRER_ID]: window.origin, [WIDGET_CONVERSATION_TYPE]: conversationType, [WIDGET_MODE]: this.config.kioskMode
                        ? OriginModeEnum.kiosk
                        : OriginModeEnum.website }),
            };
            (_b = (_a = this.handlers).starting) === null || _b === void 0 ? void 0 : _b.call(_a);
            const plugin = yield Promise.race([
                this.resolvedPlugin,
                timeout(25000),
            ]);
            (_d = (_c = this.handlers) === null || _c === void 0 ? void 0 : _c.connecting) === null || _d === void 0 ? void 0 : _d.call(_c);
            return new Promise((resolve, reject) => {
                if (plugin) {
                    plugin
                        .command("WebChatService.startChat", form)
                        .done(resolve)
                        .fail(reject);
                }
                else {
                    reject(codeError(new Error("PluginLoadTimeout"), ErrorCode.INIT_CHAT_SERVICE_FAILED));
                }
            });
        });
    }
}
